import { SET_BONUS_ADJUSTMENT_LIST_DATA, SET_BONUS_DATA, UNSET_BONUS_DATA } from '../../../store/types'
import Vue from 'vue'

export default {
  [SET_BONUS_ADJUSTMENT_LIST_DATA](state, payload) {
    Vue.set(state.bonusAdjustmentList, 'list', payload.list)
  },
  [SET_BONUS_DATA](state, payload) {
    Vue.set(state.bonusAdjustmentData, 'data', payload)
  },
  [UNSET_BONUS_DATA](state, payload) {
    Vue.set(state.bonusAdjustmentData, 'data', [])
  },
}
